import { FilterChoice } from '../../common/components/SearchHeader/types/FilterChoice';
import { TimePreset } from '../../common/schema/hannibal/types.generated';
import { SeoScenarios } from './SeoScenarios/SeoScenarios';
import { telehealthAppointmentGp, telehealthDirectoryGp } from './SeoScenarios/telehealth';
import { SegmentGetter, SeoContent } from './types';

const sanitizeInterest = (interest: string) =>
  interest === 'Internet Pornography' ? 'Internet Pornography Addiction Treatment' : interest;

export const getInterestTerm: SegmentGetter = it => sanitizeInterest(it.topic?.treatment ?? '');

export const getDayTerm: SegmentGetter = it => {
  switch (it.onlineAppointments?.date) {
    case 'Today':
      return 'today ';
    case 'Tomorrow':
      return 'tomorrow ';
    case 'Next7Days':
      return 'this week ';
  }

  return '';
};

export const getSpecialtyTerm: SegmentGetter = it => it.topic?.specialist ?? 'Specialty';

export const getSpecialtyPractitionerTerm: SegmentGetter = it =>
  it.topic?.specialist ?? 'Practitioner';

export const renderSeoContent = (filters: FilterChoice): SeoContent => {
  const { flag, onlineAppointments, topic } = filters;
  const { treatment, specialist, bulkBillingGp } = topic || {};

  if (onlineAppointments?.time === TimePreset.AfterHours) {
    return SeoScenarios.afterHoursAppointment(filters);
  } else if (treatment) {
    return onlineAppointments
      ? SeoScenarios.appointmentInterest(filters)
      : SeoScenarios.directoryInterest(filters);
  } else if (flag === 'telehealth') {
    if (!specialist) {
      return onlineAppointments
        ? SeoScenarios.telehealthAppointment(filters)
        : SeoScenarios.telehealth(filters);
    } else if (specialist === 'GP') {
      return onlineAppointments ? telehealthAppointmentGp(filters) : telehealthDirectoryGp(filters);
    } else {
      return onlineAppointments
        ? SeoScenarios.telehealthSpecialtyAppointments(filters)
        : SeoScenarios.telehealthSpecialty(filters);
    }
  } else if (bulkBillingGp) {
    return onlineAppointments
      ? SeoScenarios.bookOnlineBulkBillingGp(filters)
      : SeoScenarios.bulkBillingGp(filters);
  } else {
    return onlineAppointments && specialist
      ? SeoScenarios.specialtyAppointment(filters)
      : SeoScenarios.genericDirectory(filters);
  }
};
